import { AppointmentAthleteRetrieve } from 'types';

type AthleteAppointmentCategories = {
  inAppointment: AppointmentAthleteRetrieve['athleteAppointments'];
  checkedIn: AppointmentAthleteRetrieve['athleteAppointments'];
};

function categorizeAthleteAppointments(
  athleteAppointments: AppointmentAthleteRetrieve['athleteAppointments'],
): AthleteAppointmentCategories {
  return {
    inAppointment: athleteAppointments.filter(
      ({ isReserved, isCheckedIn, isNoShow, isLateCancel }) =>
        (isReserved || isCheckedIn) && !isNoShow && !isLateCancel,
    ),
    checkedIn: athleteAppointments.filter(({ isCheckedIn }) => isCheckedIn),
  };
}

export type UseAppointmentStats = {
  inAppointmentCount: number;
  checkedInCount: number;
};

export function useAppointmentStats(
  appointmentData: AppointmentAthleteRetrieve | undefined,
): UseAppointmentStats {
  if (!appointmentData) {
    return {
      inAppointmentCount: 0,
      checkedInCount: 0,
    };
  }

  const { inAppointment, checkedIn } = categorizeAthleteAppointments(appointmentData.athleteAppointments);

  return {
    inAppointmentCount: inAppointment.length,
    checkedInCount: checkedIn.length,
  };
}
